/*** Pre Define Constant Values For Product Listing Api Call Start ***/
// const shopUrl = "https://"+window.Shopify.shop;
// const collectionHandel = "engagement-rings-melbourne";
/*** Pre Define Constant Values For Product Listing Api Call End ***/

/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); (i < 500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 500; (i < 1000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 1000; (i < 1500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 1500; (i < 2000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 2000; (i < 3000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 3000; (i < 4000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 4000; (i < 4500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 4500; (i < 5000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 5000; (i < 5500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 5500; (i < 6000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 6000; (i < 6500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 6500; (i < 7000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);  
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}
  
function price_slider_render(min_price,max_price,option,filterLabel){
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              emptyProductResultDiv();         
              if(option == true) {                         
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end                               

                 if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    ajaxDataCall();
                 }
                 slide = '';
                 return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);

                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val(''); 
                     setTimeout(function(){
                       ajaxDataCall();
                     }, 10);
                   }

                   setTimeout(function(){
                     option = true;
                   }, 25); 
                   slide = '';
                   
                   return false;
                }
            }
             
        });
  		  
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);  		 
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		jQuery('#price_from').val(formatted_max_price);
		return false;
	} else {
		var price_min = jQuery('#price_from').val();
	}
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
	var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
	if (isNaN(price_min_value) != false) {    
        alert(translations.titlePleaseEnterValueInNumber);  
		jQuery('#price_from').val(formatted_min_price);
        return false;
	} else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);		
		jQuery('#price_from').val(formatted_min_price);
		return false;
	} else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
		price_slider_render(default_price_min, price_max_value, false, filterLabel);
		return false;
	}

	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
	if ($('#price_to').val() == ''){
		var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		$('#price_to').val(formatted_min_price);        
		return false;
	} else {
		var price_max = $('#price_to').val();        
	}

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
	if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
		jQuery('#price_to').val(formatted_max_price);
        return false;
	} else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
		jQuery('#price_to').val(formatted_max_price);        
		return false;
	} else if (price_min_value == '') {
		jQuery('#price_from').val(price_min_value);
	}

	jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
	jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
	price_slider_render(price_min_value, price_max_value, false, filterLabel);
}

function getPriceWithoutSymbolAndCommas(input_price) {
  var price = input_price;
  if(input_price.indexOf("£") >= 0){
    price = input_price.replace('£', '');
    price = price.replace(/[^\d\.]/g, '');    
  }else if(input_price.indexOf("$") >= 0){
    price = input_price.replace('$', '');
    price = price.replace('.00', '');
    price = price.replace(/,/g, ''); 
  }else if(input_price.indexOf("€") >= 0){
    price = input_price.replace('€', '');    
    price = price.replace(',00', ''); 
    price = price.replace(/\./g, '');
  }
  
  return price;
}
/*** Diamond Price Filter End ***/

/*** New In Tag Helper Start ***/
function isNewProduct(product, daysThreshold) {
  var threshold = daysThreshold || 30; // show "New In" for products added within 30 days
  if (!product.created_at) return false;
  var createdAt = new Date(product.created_at);
  var now = new Date();
  var diffMs = now - createdAt;
  var diffDays = diffMs / (1000 * 60 * 60 * 24);
  return diffDays <= threshold;
}
/*** New In Tag Helper End ***/

/*** Sort Filter Start ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyProductResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  
  jQuery('#sort_by').val(sort_by);

  jQuery('.tps-sort-by-value').html('<span>'+sort_title+'</span>');
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sort_by).addClass('active');
  
  jQuery('#page_no').val(1);
  
  ajaxDataCall(); 
  
  updateSessionFilters(session_variable+'-other-data','Sort-By',sort_by);
  updateSessionFilters(session_variable+'-other-data','Sort-Title',sort_title);
});
/*** End ***/

/*** Set Session Selected Sort Filter Start ***/
function setSessionSelectedSortValues(sortBy,sortTitle) {  
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sortBy).addClass('active');  

  jQuery('.tps-sort-by-value').html(sortTitle);
}
/*** Set Session Selected Sort Filter End ***/

function tpsCloseFilter(){ 
  jQuery('.tps-sort-option').removeClass('tps-mobile-filters');
}

/*** CheckBox Type Filter Selection Common Function Start ***/
function setSettingCheckboxtypeFilter(ele,parentClass,valueid,filter){  
     var filter_value = jQuery(ele).find("input").attr('data-value');
     var filterLable = filter.toLowerCase(); 
     emptyProductResultDiv();

     if(jQuery(ele).hasClass('selected')){
        filter_value = '';
        jQuery(ele).removeClass('selected');
        $('#'+valueid).val('');
     }else{     
        jQuery('.tps-filter-'+filterLable+'-li').removeClass('selected');
        jQuery(ele).addClass('selected');
         $('#'+valueid).val(filter_value);
     }  
       
    jQuery('#page_no').val(1);
    ajaxDataCall();
    updateSessionFilters(session_variable+'-filters',filter, filter_value);
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSettingSelectedFilter(filterTitle,filterFunction,hasClass,filterLable);
    //end  
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Metal Filter From Applied Filter Start ***/
function removeMetalFilter(metal){ 
  jQuery('.tps-filter-metal-list input[data-value="'+metal+'"]').click();
}
/*** Remove Metal Filter From Applied Filter End ***/

/*** Remove Style Filter From Applied Filter Start ***/
function removeStyleFilter(style){ 
  jQuery('.tps-filter-style-list input[data-value="'+style+'"]').click();
}
/*** Remove Style Filter From Applied Filter End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSettingSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {    
	if (input_value == 'price') {
		$('.tps-selected-filter-container').find('li[data-input="price"]').remove();
	}else if (input_value == 'shape') {     
		$('.tps-selected-filter-container').find('li[data-input="shape"]').remove();
	}else if (input_value == 'style') {
		$('.tps-selected-filter-container').find('li[data-input="style"]').remove();
	}else if (input_value == 'metal') {
		$('.tps-selected-filter-container').find('li[data-input="metal"]').remove();
    }
  
	var value = filter_value.split(':');
   
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter-value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
		if ($('#' + value[0] + '-container').length > 0) {
			$('#' + value[0] + '-container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + value[0] + ':</span></ul>';
			$('.tps-selected-filter-container').append(elecontainer);
			$('#' + value[0] + '-container').append(html);
		}    
	} else {
		$('.tps-selected-filter-container').find('li[data-filter-value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '-container li').length == 0) {
			$('#' + value[0] + '-container').remove();
		}
	}
	if ($('.tps-selected-filter-container li').length > 0) {
		$('.tps-selected-filter-wrapper').show();
	} else {
		$('.tps-selected-filter-wrapper').hide();
	}
}
/*** Set selected filters for session filters after reloading page end ***/

/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedSettingFilterValues(session_data) {  
  $.each(session_data, function(key,value){ 
    var inputKey = key.toLowerCase();
    
    if(key == 'Shape' || key == 'Metal' || key == 'Style'){    
        if(value != ''){
          var inputValues = value.toString();          
          $('#setting_'+inputKey).val(inputValues);
    
          var filterArrayKey = key;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedSettingCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(key == 'Price'){
      $('#'+inputKey+'_left_hidden').val(value[0]);
      $('#'+inputKey+'_right_hidden').val(value[1]);
    }
     
  });    
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedSettingCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.toLowerCase();
      
      if(filterTitle != 'shape'){
        filterValue = filterValue.replace(/\s+/g, '-');
      }
    
      $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
      $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected');
       
      var filterSelectedValues = filterKey+': '+value; 
      setSettingSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,filterTitle);
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/


/* ============================================================
   PAGINATION MODE HELPER
   Reads the hidden input set by the Liquid section setting.
   Returns 'load_more' or 'pagination'
   ============================================================ */
function getPaginationMode() {
  var el = document.getElementById('tps_pagination_mode');
  return el ? el.value : 'load_more';
}

/* ============================================================
   URL QUERY-PARAM HELPERS
   Used to persist the current page number across refreshes.
   Only active when pagination mode = 'pagination'.
   ============================================================ */

/** Read ?tps_page=N from the current URL. Returns 1 if not present. */
function getPageFromUrl() {
  var params = new URLSearchParams(window.location.search);
  var p = parseInt(params.get('tps_page'), 10);
  return (p && p > 0) ? p : 1;
}

/** Push/replace ?tps_page=N into the browser URL without reloading. */
function setPageInUrl(pageNum) {
  var params = new URLSearchParams(window.location.search);
  if (pageNum === 1) {
    params.delete('tps_page');          // keep URL clean on page 1
  } else {
    params.set('tps_page', pageNum);
  }
  var newUrl = window.location.pathname +
               (params.toString() ? '?' + params.toString() : '') +
               window.location.hash;
  history.replaceState(null, '', newUrl);
}

/* ============================================================
   SHOW / HIDE THE CORRECT PAGINATION UI
   Also restores page number from URL when in pagination mode.
   ============================================================ */
function applyPaginationMode() {
  var mode = getPaginationMode();
  if (mode === 'pagination') {
    jQuery('#tps_load_more_section').hide();
    jQuery('#tps_pagination_section').show();

    /* Restore page from URL on refresh / direct link */
    var restoredPage = getPageFromUrl();
    if (restoredPage > 1) {
      jQuery('#page_no').val(restoredPage);
    }
  } else {
    jQuery('#tps_load_more_section').show();
    jQuery('#tps_pagination_section').hide();
  }
}

/* Run once on page load */
jQuery(document).ready(function () {
  applyPaginationMode();
});


/* ============================================================
   NUMBERED PAGINATION RENDERER
   Called after ajaxDataCall() fetches & renders products.
   ============================================================ */
function renderNumberedPagination(currentPage, totalProducts, productsPerPage) {
  var totalPages = Math.ceil(totalProducts / productsPerPage);
  var $list = jQuery('#tps_pagination_list');
  $list.empty();

  if (totalPages <= 1) {
    jQuery('#tps_pagination_section').hide();
    return;
  }

  jQuery('#tps_pagination_section').show();

  /* ---- Prev button ---- */
  if (currentPage > 1) {
    $list.append(
      '<li><a onclick="goToPage(' + (currentPage - 1) + ')" aria-label="Previous">&lsaquo;</a></li>'
    );
  } else {
    $list.append('<li class="tps-preview-nav tps-page-disabled"><span>&lsaquo;</span></li>');
  }

  /* ---- Page number buttons with smart ellipsis ---- */
  var pages = buildPageRange(currentPage, totalPages);
  for (var i = 0; i < pages.length; i++) {
    var p = pages[i];
    if (p === '...') {
      $list.append('<li class="tps-page-dots"><span>&hellip;</span></li>');
    } else if (p === currentPage) {
      $list.append('<li class="tps-page-active"><span>' + p + '</span></li>');
    } else {
      $list.append(
        '<li><a onclick="goToPage(' + p + ')">' + p + '</a></li>'
      );
    }
  }

  /* ---- Next button ---- */
  if (currentPage < totalPages) {
    $list.append(
      '<li><a onclick="goToPage(' + (currentPage + 1) + ')" aria-label="Next">&rsaquo;</a></li>'
    );
  } else {
    $list.append('<li class="tps-next-nav tps-page-disabled"><span>&rsaquo;</span></li>');
  }

  /* ---- Update "showing X of Y" in pagination section ---- */
  var showFrom = (currentPage - 1) * productsPerPage + 1;
  var showTo   = Math.min(currentPage * productsPerPage, totalProducts);
  jQuery('.tps-pagination-showing').html(showFrom + '–' + showTo);
  jQuery('#tps_pagination_section .tps-total-products').html(addCommas(totalProducts));
}

/* Builds a smart page-number array, e.g. [1, '...', 4, 5, 6, '...', 12] */
function buildPageRange(current, total) {
  var delta = 2; // pages shown around current
  var range = [];
  var rangeWithDots = [];
  var l;

  for (var i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
      range.push(i);
    }
  }

  for (var j = 0; j < range.length; j++) {
    if (l) {
      if (range[j] - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (range[j] - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(range[j]);
    l = range[j];
  }

  return rangeWithDots;
}

/* Called when user clicks a page number */
function goToPage(pageNum) {
  jQuery('#page_no').val(pageNum);
  /* Persist page in URL so a refresh lands on the same page */
  setPageInUrl(pageNum);
  jQuery('.tps-productlist-result-grid-view-items-list').html('');
  jQuery('.tps-productlist-result-grid-view-items-list').removeClass('tps-no-product-found');
  ajaxDataCall();
  /* Smooth scroll to top of product grid */
  var gridTop = jQuery('#tps_product_grid_view_container').offset();
  if (gridTop) {
    jQuery('html, body').animate({ scrollTop: gridTop.top - 80 }, 400);
  }
}


/*** Get All Setting Products Start ***/ 
function ajaxDataCall(){   
   
   var session_variable = jQuery("#session_variable").val();
   var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
     
   jQuery(".tps-productlist-result-grid-view-loader").show();
   jQuery("#tps_product_count").html("<span class='tps-product-count-loader'></span>");
   jQuery("#tps_filtered_count").html("<span class='tps-product-count-loader'></span>");
   var ringSettingUrl = shopUrl+'collections/'+collectionHandel+'/products.json?limit=250&page=1';
   
   var prodGridView = '';

   var session_flag = 0;
   if(session_other_data != '' && session_other_data != null){
      if(session_other_data['Product-Id'] != null && session_other_data['Product-Id'] != '' && session_other_data['Product-Id'] != undefined){
        if(session_other_data['Product-Id'][0] != undefined){
          var session_flag = 1;
        }
      }
   }

  var productsPerPage = document.querySelector('#products_per_page').value;
  var paginationMode  = getPaginationMode();

  if(session_flag != 0){
    var recentPageNo = session_other_data['Recent-Product-Page-No'][0];
    jQuery("#page_no").val(recentPageNo);
    var pageNo = recentPageNo;
    var productShow = recentPageNo * productsPerPage;
    var showFrom = 0;
    var showTo = parseInt(productShow) - 1;
  }else{
    /* For numbered pagination always show exactly one page's worth.
       For load-more, behaviour is unchanged (append). */
    var pageNo = jQuery("#page_no").val();
    if (paginationMode === 'pagination') {
      var showFrom = productsPerPage * (pageNo - 1);
      var showTo   = parseInt(showFrom) + parseInt(productsPerPage) - 1;
    } else {
      /* Load-more: accumulate from page 1 up to current pageNo */
      var productShow = pageNo * productsPerPage;
      var showFrom = productsPerPage * (pageNo - 1);
      var showTo   = parseInt(showFrom) + parseInt(productsPerPage) - 1;
    }
  }       
  
   abortAjax(xhr);

   var productDataArray = [];
   
   xhr = $.ajax({
     type: 'GET',
     url: ringSettingUrl,
     dataType: 'json',
     success: function (data){  
       var productsData = data && Array.isArray(data.products) ? productFilters(data) : [];
       
       var productCount = productsData.length;
       jQuery("#tps_product_count").html(""+addCommas(productCount)+"");
       jQuery("#tps_filtered_count").html(""+addCommas(productCount)+"");
       jQuery("#total_products_count").val(productCount);
       jQuery(".tps-total-products").html(addCommas(productCount));

       if(parseInt(productCount) > 0){
         $('.tps-product-grid-view-container').removeClass('tps-no-product');
         var swatchesData = new Array();

         /* For numbered pagination, clear list before rendering (fresh page).
            For load-more, items are appended (existing behaviour). */
         if (paginationMode === 'pagination') {
           jQuery('.tps-productlist-result-grid-view-items-list').html('');
         }

         $.each(productsData, function (i, product) {    
           if(i >= showFrom && i <= showTo){
             prodGridView += getProductGridViewLayout(product,collectionHandel,i);  
           }
         });
         
         jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);  
         initShopPayTermsBanners(
            jQuery('.tps-productlist-result-grid-view-items-list')
        );
         setTimeout(function () {
            document.querySelectorAll('shopify-payment-terms').forEach(function(el){
                if (typeof el.initialize === 'function') {
                    el.initialize();
                }
            });
        }, 100);
         // Re-initialise XB Wishlist for newly rendered product cards
          setTimeout(function () {
            if (window.XBWishlist && typeof window.XBWishlist.init === 'function') {
              window.XBWishlist.init();
            } else if (window.xbWishlist && typeof window.xbWishlist.init === 'function') {
              window.xbWishlist.init();
            }
          }, 100);       
       } else {
         //no products found
          jQuery('.tps-load-more-button-section').hide();
          jQuery('#tps_pagination_section').hide();
          jQuery('.tps-productlist-result-grid-view-items-list').html('');
          prodGridView += '<span class="tps-no-product-found">'+translations.titleNoProductFound+' <a class="tps-reset-filter tps-reset-popup" onclick="resetFilters(\'all\')">Reset Filters</a>' + '</span>';
          jQuery('.tps-productlist-result-grid-view-items-list').addClass('tps-no-product-found'); 
          jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);  
       }            
       
       /* ---- LOAD MORE logic (unchanged) ---- */
       if (paginationMode === 'load_more') {
         if(productCount < productsPerPage || productCount == productsPerPage){
           var previous_page_no = parseInt(pageNo)-1;
           var total_previous_products = previous_page_no*productsPerPage;
           if(productCount == 0){
             var products_viewed = productCount;
           }else{
             var products_viewed = parseInt(total_previous_products)+parseInt(productCount);            
           }                    
           jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
           jQuery(".tps-load-more").hide();
           jQuery(".tps-load-more").addClass("load-more-active");
         }else{
           jQuery(".tps-load-more").show();
           jQuery(".tps-load-more").removeClass("load-more-active");
           if(pageNo == 1){     
             var products_viewed = productsPerPage;
           }else{
             var products_viewed = pageNo*parseInt(productsPerPage);
             if(products_viewed > productCount){
               products_viewed = productCount;
               jQuery(".tps-load-more").hide(); 
             }else if(products_viewed == productCount){
               jQuery(".tps-load-more").hide(); 
             } 
           }    
           jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
         }
       }

       /* ---- NUMBERED PAGINATION logic ---- */
       if (paginationMode === 'pagination') {
         renderNumberedPagination(parseInt(pageNo), productCount, parseInt(productsPerPage));
       }

       /* ---- session product focus (unchanged) ---- */
       if(session_flag != 0){
         var recentProduct = session_other_data['Product-Id'][0];            
         focusRecentProduct(recentProduct);            
       }             

       jQuery(".tps-productlist-result-grid-view-loader").hide();

       /* For load-more, advance page_no to the next page */
       if (paginationMode === 'load_more') {
         var page_id = parseInt(pageNo)+1;  
         jQuery('#page_no').val(page_id);  
       }
       /* For numbered pagination, page_no stays as-is (set by goToPage) */

       //when filter applied focus on diamond listing
        if ($('.tps-selected-filter-wrapper').is(':visible')) {
          $('html, body').animate({
            scrollTop: $('.tps-productlist-result-grid-view-items-list').offset().top - 200
          }, 'slow');
        }
     }

   });
}
/*** Get All Setting Products End ***/ 

/*** Assign Lazy Loading To Grid View Result Product Images Start ***/
function assignLazyLoadingToProductImages() {
  jQuery('.tps-product-first-image').Lazy({  			
        visibleOnly : true,
        bind : 'scroll',
        threshold : 0,
        onError : function(imgEle) {
            imgEle.attr('src', imgEle.data('placeholder-img'));
        },
        beforeLoad : function(imgEle) {  				
  				imgEle.css('visibility', 'visible');
  			},
    });
}
/*** Assign Lazy Loading To Grid View Result Product Images End ***/

/*** Focus Recently View Product Start ***/
function focusRecentProduct(product_id) {
  var target = '.product-grid-item-'+product_id;

  if($(target).length) {
    $(target).addClass('tps-recent-viewed-product');
    $('html, body').animate({
          scrollTop: $(target).offset().top - 300
    }, 'slow'); 
  }  
  updateSessionFilters(session_variable+'-other-data','Product-Id', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-product'); }, 1500);
}
/*** End ***/

/* Hydrates every ".tps-shoppay-slot" found within $scope with a real Shop Pay
   Installments banner. IMPORTANT: we do NOT clone the hidden source node -
   shopify-payment-terms renders its visible content into a Shadow DOM, and
   cloneNode()/jQuery.clone() does not copy an element's shadow tree. Instead
   we create a brand-new <shopify-payment-terms> element and copy its
   attributes over, so the browser builds a fresh shadow root for it using
   those attributes when it's connected to the DOM. */
function initShopPayTermsBanners($scope) {

    if (!$scope || !$scope.length) return;

    $scope.find('.tps-shoppay-slot').each(function () {

        var $slot = $(this);

        if ($slot.data('loaded')) return;

        var productId = $slot.data('product-id');
        var variantId = $slot.data('variant-id');

        var source = document.querySelector(
            '.tps-spi-source[data-product-id="' + productId + '"] form'
        );

        if (!source) return;

        var clone = source.cloneNode(true);

        clone.querySelector('input[name="id"]').value = variantId;

        var paymentTerms = clone.querySelector('shopify-payment-terms');

        if (paymentTerms) {
            paymentTerms.setAttribute('variant-id', variantId);
        }

        $slot.html(clone);

        $slot.data('loaded', true);
    });

}

/*** Get Product Grid View layout Start ***/ 
function getProductGridViewLayout(product,collectionHandel,diamondIndex){  
  var wishlistProducts = jQuery("#wishlist_products").val()?.split(",") || [];
  var banner_display_count = jQuery('#tps_banner_row_count').val();
  var diamond_index = (diamondIndex % 40)+1;   

  const shapeOption = product.options.find(
    option => option.name?.toLowerCase() === 'shape'
  );
  var canBeMatchWith = shapeOption?.values?.join(',');
 
   //Get Hover Image
  var images = product.images;
  const altAndSrc = images.map(image => ({
    alt: image.alt,
    src: image.src
  }));
  
  var pageNo = jQuery("#page_no").val();
  var metalFilter = jQuery("#setting_metal").val();
  var filteredMetal = metalFilter.replace(/^18K\s/, '');
   var productId = product.id;
   var productHandle = product.handle;
  var productArray = ["8092737077418", "8083539656874", "8072311537834", "8072313110698"];  
  
  const filteredImages = altAndSrc.filter(item => 
    item.alt && typeof item.alt === 'string' && item.alt.startsWith(filteredMetal)
  );
   
  
  const singleSrc = filteredImages.length > 0 
    ? (filteredImages[1] ? filteredImages[1].src : filteredImages[0].src)
    : altAndSrc[0].src;
    
  
  var produtSwaches = getProductSwatches(product,collectionHandel);  
  var productVariant = getProductVariant(product,collectionHandel);   
  cacheQuickViewProduct(product, productVariant, produtSwaches, images, isNewProduct(product, 30));
  
  var productPrice = Shopify.formatMoney(productVariant[0].price * 100, theme.moneyFormat);
      productPrice = productPrice.substr(0, productPrice.indexOf('.'));
  var productComparePrice = Shopify.formatMoney(productVariant[0].comparePrice * 100, theme.moneyFormat);
      productComparePrice = productComparePrice.substr(0, productComparePrice.indexOf('.'));
      
  var totPrice = Number(productVariant[0].comparePrice - productVariant[0].price);
      totPrice = Shopify.formatMoney(totPrice * 100, theme.moneyFormat);
      totPrice = totPrice.substr(0, totPrice.indexOf('.'));
  
  var productImage = productVariant[0].image;
  var productHoverImage = productVariant[0].secondImage;
  var isPlaceholderImage = !!productVariant[0].isPlaceholder;

  // Only resize real Shopify CDN images. Skip resizing (and skip crashing on
  // a non-string) when a placeholder had to be used instead.
  if(!isPlaceholderImage && typeof productImage === 'string'){
    if(productImage.includes('.png')){
      productImage = productImage.replace(".png","_300x300.png");
    }else if(productImage.includes('.jpg')){
      productImage = productImage.replace(".jpg","_300x300.jpg");
    }
  }

  var productImageClass = 'tps-productlist-item-img tps-product-first-image' + (isPlaceholderImage ? ' tps-no-image' : '');
  var productHoverImageClass = 'tps-productlist-item-img tps-product-second-image' + (isPlaceholderImage ? ' tps-no-image' : '');
  var productImageAlt = isPlaceholderImage ? (product.title+' - image coming soon') : product.title;

  var productGrid = '';
  productGrid += '<li class="tps-productlist-result-grid-view-item product-grid-row product-grid-item-'+product.id+'" data-id="'+product.id+'" data-page="'+pageNo+'">'; 
  // New In badge
  if (isNewProduct(product, 30)) {
    productGrid += '<div class="tps-product-badge tps-badge-new-in">New In</div>';
  }
  productGrid += '<div class="tps-productlist-item-media-div-section tps-productlist-item-media-div-'+product.id+'">';
  
  productGrid += '<div class="tps-productlist-item-media-div">';

  const widgetContainerId = `ring-try-on-widget-${product.id}`;
  productGrid += '<div class="tps-ring-try-on-section"><div class="tps-try-on-button" id="'+ widgetContainerId +'" data-image-url-white="" data-image-url-yellow="" data-image-url-rose="" data-product-id="'+ product.id +'"></div></div>';

  // setTimeout(function () {
  //   const container = document.getElementById(widgetContainerId);
  //   // drawTryOnButton(container);
  //   // checkCameraAvailability();
  // }, 100);

  productGrid += '<a href="'+productVariant[0].url+'" class="tps-quickview-trigger" data-id="'+product.id+'" data-page="1">';
  productGrid += '<img class="'+productImageClass+'" data-is-placeholder="'+isPlaceholderImage+'" data-placeholder-img="'+productImage+'" data-src="'+productImage+'" alt="'+productImageAlt+'" title="'+productImageAlt+'" src="'+productImage+'" width="300" height="300">';
  productGrid += '<img class="'+productHoverImageClass+'" data-is-placeholder="'+isPlaceholderImage+'" data-placeholder-img="'+productHoverImage+'" data-src="'+productHoverImage+'" alt="'+productImageAlt+'" title="'+productImageAlt+'" src="'+productHoverImage+'" width="300" height="300">';
  productGrid += '</a>';
  productGrid += '</div>';
  productGrid += '</div>';

  // XB Wishlist button
productGrid += '<div class="tps-wishlist-btn-wrapper">';
productGrid += '<div class="xb-wishlist__btn-custom">';
productGrid += '  <div class="xb-wishlist__add"'
             +    ' xb-product-id="' + product.id + '"'
             +    ' xb-product-title="' + product.title.replace(/"/g, '&quot;') + '"'
             +    ' xb-product-variant="' + productVariant[0].id + '"'
             +    ' xb-is-in-stock="true"'
             +    ' xb-product-handle="' + product.handle + '"'
             + '>';
productGrid += '    <button aria-label="Add to Wishlist" title="Add to Wishlist">';
productGrid += '      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF4A71" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
productGrid += '    </button>';
productGrid += '  </div>';
productGrid += '  <div class="xb-wishlist__remove" xb-product-id="' + product.id + '" xb-is-in-stock="true">';
productGrid += '    <button aria-label="Remove from Wishlist" title="Remove from Wishlist">';
productGrid += '      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#FF4A71" stroke="#FF4A71" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
productGrid += '    </button>';
productGrid += '  </div>';
productGrid += '</div>';
productGrid += '</div>';
  
  productGrid += '<div class="tps-productlist-item-wrapper">';
  productGrid += '<a class="tps-quickview-trigger" href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">'
  productGrid += '<div class="tps-productlist-item-view-title">'+product.title+'</div>';  
  productGrid += '</a>';
  if(produtSwaches != '' && produtSwaches != null){
    productGrid += '<div class="tps-productlist-item-swatches">';
    productGrid += '<span class="tps-productlist-item-swatches-label">Color</span>';
    $.each(produtSwaches, function (i, swatch) {  
      
      var metalSwatch = swatch.metal;
      metalSwatch = metalSwatch.replace(/^18K\s/, '');      
      var matchingImages = images.filter(image => image.alt === metalSwatch);
      const imageSrcs = matchingImages.map(image => image.src);
      var hoverImageUrl = swatch.secondImage;      
      var varSku = swatch.sku;
      var varMetal = swatch.metal;
      var varshape = swatch.shape;      
      productGrid += '<div class="tps-productlist-item-swatch tps-productlist-item-swatch-'+swatch.id+' '+swatch.active+'" parent-id="'+product.id+'" data-id="'+swatch.id+'">';
      productGrid += '<div title="'+swatch.metal+'" data-id="'+swatch.id+'" onclick="changeProductData(`'+product.title+'`,`'+product.id+'`,`'+product.body_html+'`,`'+productHandle+'`,`'+swatch.id+'`,`'+swatch.metal+'`,`'+swatch.price+'`,`'+varSku+'`,`'+varshape+'`,`'+swatch.comparePrice+'`,`'+swatch.image+'`,`'+swatch.url+'`,`'+hoverImageUrl+'`)">';
      productGrid += '<span class="tps-productlist-item-metal-icon metal-'+swatch.class+'">'+swatch.metal+'</span>';
      productGrid += '</div>';
      productGrid += '</div>';
    });
    productGrid += '</div>';
  }
  
  productGrid += '<div class="tps-productlist-item-view-info tps-productlist-item-view-info-'+product.id+'">';
  productGrid += '<a href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-price">'; 
  productGrid += '<span>'+productPrice+'</span>';
  if (
    productComparePrice != null &&
    productComparePrice != undefined &&
    productComparePrice != '' &&
    productComparePrice != 0 &&
    productComparePrice != '0' && 
    productComparePrice != '$0'
  ){
    productGrid += '<span id="tps_compare_price"><del>'+productComparePrice+'</del></span>'
    productGrid += '<span id="tps_sale_price">Save '+totPrice+'</span>'
  }
  productGrid += '</div>';
  productGrid += '</a>';
  // Shop Pay Installments banner slot - hydrated after insertion by initShopPayTermsBanners()  
  //console.log("productVariant[0]",productVariant[0]);
  productGrid += '<div class="tps_moreinfo">';  
  productGrid += '<div class="tps-product-form product-form__buttons">';
  productGrid += '<a class="tps-listing-view-more-btn" href="'+productVariant[0].url+'" data-id="'+product.id+'" data-page="1"><span>More Info</span></a>';
  productGrid += '<button id="tps_choose_this_listing_setting" name="choose_this_setting" class="tps-choose-this-listing-setting" tps-listing-btn" onclick="choose_this_listing_setting(this)" data-id="'+product.id+'" data-handle="'+product.handle+'" data-title="'+product.title+'" data-url="'+productVariant[0].url+'" data-varId="'+productVariant[0].id+'" data-sku="'+productVariant[0].sku+'" data-price="'+productVariant[0].price+'" data-compprice="'+productVariant[0].comparePrice+'" data-forPrice="'+productPrice+'" data-metal="'+productVariant[0].metal+'" data-centerStone="'+productVariant[0].shape+'" data-match="'+canBeMatchWith+'" data-img="'+productVariant[0].image+'" data-desc="'+product.body_html+'" >';
  productGrid += '<span>Choose Setting</span>';
  productGrid += '</button>';
  productGrid += '</div>';
  productGrid += '<span class="tps-finance">';
  productGrid += '<div class="tps-productlist-item-shoppay">';
  productGrid += '<div class="tps-shoppay-slot"';
  productGrid += ' data-product-id="' + product.id + '"';
  productGrid += ' data-variant-id="' + productVariant[0].id + '">';
  productGrid += '</div>';
  productGrid += '</div>';
  productGrid += '</span>';
  productGrid += '</div>';
  productGrid += '</div>';
  productGrid += '</div>';
  productGrid += '</li>';

  //banner start  
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){    
    banner_display_count = parseInt(banner_display_count)+1;
  }
  
  if(diamond_index == banner_display_count){
      var bannerHtml = $('#tps_banner_blog_'+pageNo).html();
      if(bannerHtml != '' && bannerHtml != undefined){
        productGrid += '<li class="tps-diamondlist-banner-section">';
        productGrid += '<div class="tps-diamond-listing-page-banner">'+bannerHtml+'</div>';
        productGrid += '</li>';
      }
  }  
  //banner end

  return productGrid;
}
/*** Get Product Grid View layout End ***/

/*** On Swatches Click Change Variant Data Start ***/
function changeProductData(productTitle,productId,productHandle,productDesc,variantId,variantTitle,variantPrice,variantSku,variantShape,variantComparePrice,variantImage,variantUrl,hoverImg) { 
  // Values arrive as literal strings baked into an onclick attribute, so a
  // missing image can show up as the literal text "undefined"/"null" rather
  // than a real falsy value. Route everything through the same safe resolver.
  var mainImageResult = getSafeImageUrl(variantImage);
  var hoverImageResult = getSafeImageUrl((hoverImg && hoverImg !== 'undefined' && hoverImg !== 'null') ? hoverImg : mainImageResult.url);
  variantImage = mainImageResult.url;
  hoverImg = hoverImageResult.url;
  var isPlaceholderImage = mainImageResult.isPlaceholder;
  var mediaImageClass = 'tps-productlist-item-img tps-product-first-image' + (isPlaceholderImage ? ' tps-no-image' : '');
  var mediaHoverClass = 'tps-productlist-item-img tps-product-second-image' + (isPlaceholderImage ? ' tps-no-image' : '');
  var mediaAlt = isPlaceholderImage ? (productTitle+' - image coming soon') : productTitle;

  jQuery('.product-grid-item-'+productId+' .tps-productlist-item-swatch').removeClass('active');
  jQuery('.tps-productlist-item-swatch-'+variantId).addClass('active');
  jQuery('.tps-productlist-item-media-div-'+productId).addClass('tps-gallery-loading');   
  var productPrice = Shopify.formatMoney(variantPrice * 100, theme.moneyFormat);
  productPrice = productPrice.substr(0, productPrice.indexOf('.'));

  var productComparePrice = Shopify.formatMoney(variantComparePrice * 100, theme.moneyFormat);
      productComparePrice = productComparePrice.substr(0, productComparePrice.indexOf('.'));
      
  var totPrice = Number(variantComparePrice - variantPrice);
      totPrice = Shopify.formatMoney(totPrice * 100, theme.moneyFormat);
      totPrice = totPrice.substr(0, totPrice.indexOf('.'));

  var productMedia = '';
  productMedia += '<div class="tps-productlist-item-media-div">';

  const widgetContainerId = `ring-try-on-widget-${productId}`;
  productMedia += '<div class="tps-ring-try-on-section"><div class="tps-try-on-button" id="'+ widgetContainerId +'" data-image-url-white="" data-image-url-yellow="" data-image-url-rose="" data-product-id="'+ productId +'"></div></div>';

  // setTimeout(function () {
  //   const container = document.getElementById(widgetContainerId);
  //   // drawTryOnButton(container);
  //   // checkCameraAvailability();
  // }, 100);

  productMedia += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productMedia += '<img class="'+mediaImageClass+'" data-is-placeholder="'+isPlaceholderImage+'" data-placeholder-img="'+variantImage+'" alt="'+mediaAlt+'" title="'+mediaAlt+'" src="'+variantImage+'" width="300" height="300">';
  productMedia += '<img class="'+mediaHoverClass+'" data-is-placeholder="'+isPlaceholderImage+'" data-placeholder-img="'+hoverImg+'" alt="'+mediaAlt+'" title="'+mediaAlt+'" src="'+hoverImg+'" width="300" height="300">';
  productMedia += '</a>';
  productMedia += '</div>';
  jQuery('.tps-productlist-item-media-div-'+productId).html(productMedia);  

  var productinfo = '';
  productinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productinfo += '<div class="tps-productlist-item-view-price">'; 
  productinfo += '<span>'+productPrice+'</span>';
  if (
    productComparePrice != null &&
    productComparePrice != undefined &&
    productComparePrice != '' &&
    productComparePrice != 0 &&
    productComparePrice != '0' &&
    productComparePrice != '$0'
  ){
    productinfo += '<span id="tps_compare_price"><del>'+productComparePrice+'</del></span>'
    productinfo += '<span id="tps_sale_price">Save '+totPrice+'</span>'
  }
  productinfo += '</div>';
  productinfo += '</a>';
  // Shop Pay Installments banner slot - hydrated right after we inject this HTML below 

  productinfo += '<div class="tps_moreinfo">';
  productinfo += '<div class="shop-pay-container" data-product-id="' + productId + '"></div>';
  productinfo += '<div class="tps-product-form product-form__buttons">';
  productinfo += '<a class="tps-listing-view-more-btn" href="'+variantUrl+'" data-id="'+productId+'" data-page="1"><span>More Info</span></a>';
  productinfo += '<button id="tps_choose_this_listing_setting" name="choose_this_setting" onclick="choose_this_listing_setting(this)" class="tps-choose-this-listing-setting tps-listing-btn" data-id="'+productId+'" data-handle="'+productHandle+'" data-title="'+productTitle+'" data-url="'+variantUrl+'" data-varId="'+variantId+'" data-sku="'+variantSku+'" data-price="'+variantPrice+'" data-compprice="'+variantComparePrice+'" data-forPrice="'+productPrice+'" data-metal="'+variantTitle+'" data-centerStone="'+variantShape+'" data-match="'+variantShape+'" data-img="'+variantImage+'" data-desc="'+productDesc+'">';
  productinfo += '<span>Choose Setting</span>';
  productinfo += '</button>';
  productinfo += '</div>';
  productinfo += '</div>';
  jQuery('.tps-productlist-item-view-info-'+productId).html(productinfo);  
  
  setTimeout(function () {
    jQuery('.tps-productlist-item-media-div-'+productId).removeClass('tps-gallery-loading');  
    var terms = document.querySelector(
        '.product-grid-item-' + productId + ' shopify-payment-terms'
    );

    if (terms && typeof terms.initialize === 'function') {
        terms.initialize();
    }
}, 100);
  
  // Update XB Wishlist variant when swatch changes
  jQuery('.product-grid-item-' + productId + ' .xb-wishlist__add').attr('xb-product-variant', variantId);
  jQuery('.product-grid-item-' + productId + ' .xb-wishlist__remove').attr('xb-product-variant', variantId);

}
/*** On Swatches Click Change Variant Data End ***/

function choose_this_listing_setting(element){

    $(element).addClass("tps-loading");

    var selected_diamond = localStorage.getItem("ring-selected-diamond");

    if(selected_diamond != null && selected_diamond != undefined){

        selected_diamond = JSON.parse(selected_diamond);

        var diamond_shape = selected_diamond[0].diamond_shape;
        var diamond_title = selected_diamond[0].diamond_title;

        var ring_selected_shape = $(element).data("centerstone");

        if(diamond_shape != ring_selected_shape){

            alert(
                translations.titleSelectedRingSetting +
                " " +
                diamond_title +
                " " +
                translations.titleChangeYourDiamondOrRing
            );

            $(element).removeClass("tps-loading");
            return false;
        }
    }

    var currency_rate = parseFloat(Shopify.currency.rate);

    var product_price = parseFloat($(element).data("price"));
    var product_price_in_base_currency = product_price / currency_rate;
    product_price_in_base_currency = Math.floor(product_price_in_base_currency.toFixed(2));

    var product_compprice = parseFloat($(element).data("compprice"));
    var product_compprice_in_base_currency = product_compprice / currency_rate;
    product_compprice_in_base_currency =  Math.floor(product_compprice_in_base_currency.toFixed(2));

    var setting = [{
        "product_id": $(element).data("id"),
        "product_handle": $(element).data("handle"),
        "product_title": $(element).data("title"),
        "product_url": $(element).data("url"),
        "setting_id": $(element).data("varid"),
        "setting_sku": $(element).data("sku"),
        "setting_price": product_price_in_base_currency,
        "setting_comp_price": product_compprice_in_base_currency,
        "setting_formatted_price": $(element).data("forprice"),
        "setting_metal": $(element).data("metal"),
        "setting_center_stone": $(element).data("centerstone"),
        "setting_can_be_match_with": $(element).data("match"),
        "setting_image": $(element).data("img"),
        "setting_description": $(element).data("desc"),
        "setting_ring_size": "",
        "setting_stone_type": ""
    }];

    localStorage.setItem(
        "ring-selected-setting",
        JSON.stringify(setting)
    );

    $(element).removeClass("tps-loading");

    setSteps("setting");
}

/*** Get variant Data After Filter Apply Start ***/
function getProductVariant(product,collectionHandel){
  var variantData = new Array();
  var shapeFilter = jQuery("#setting_shape").val();  
  var metalFilter = jQuery("#setting_metal").val(); 
  var productVariants = product.variants;
  var productHandle = product.handle;   
  var productMedia = product.images;
  var i = 0;

  if(productVariants != ''){
     $(productVariants).each(function(index, option){
       var variantShape = option.option2;
       var variantMetal = option.option1;
       
       if(shapeFilter == '' && metalFilter == ''){
         if(i == 0){
           variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
           i++;
         }
       }else if(shapeFilter != '' && metalFilter != ''){
         if(shapeFilter == variantShape && metalFilter == variantMetal){
           variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
         }
       }else if(shapeFilter == '' && metalFilter != ''){
         if(metalFilter == variantMetal){  
            if(i == 0){
              variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel); 
              i++;
            }              
         }
       }else if(shapeFilter != '' && metalFilter == ''){
         if(shapeFilter == variantShape){       
           if(i == 0){
             variantData = getProductSelectedOption(option,productHandle,productMedia,collectionHandel);
             i++;
           }
         }
       }
     });
  }
  return variantData;   
}

function getProductSelectedOption(option,productHandle,productMedia,collectionHandel){
   var variantInfo = new Array();
   var variantShape = option.option2;
   var variantMetal = option.option1;
   var varientFeaturedImage  = option.featured_image;
   var rawImage = null;
   var rawSecondImage = null;

   if(varientFeaturedImage != null){
     rawImage = getImageByID(productMedia,varientFeaturedImage.id);
     rawSecondImage = getSecondImageByID(productMedia,varientFeaturedImage.id);
   }

   var imageResult = getSafeImageUrl(rawImage);
   // Fall back the hover/second image to the primary image (not the raw,
   // possibly-missing one) so a missing hover shot never breaks the swap,
   // and never leaks a stale value from a previous product (missing `var` bug).
   var secondImageResult = getSafeImageUrl(rawSecondImage || imageResult.url);

   var productUrl = '/collections/'+collectionHandel+'/products/'+productHandle+'?variant='+option.id+'&sku='+option.sku;
  
   variantInfo.push({
      id: option.id,
      sku: option.sku,
      shape: variantShape,
      metal: variantMetal,
      url: productUrl,
      image: imageResult.url,
      secondImage: secondImageResult.url,
      isPlaceholder: imageResult.isPlaceholder,
      price: option.price,
      comparePrice: option.compare_at_price,
   });

  return variantInfo;
}
/*** Get variant Data After Filter Apply End ***/

/*** Get Product Swatches Data Start ***/
function getProductSwatches(product,collectionHandel){
   var swatchesData = new Array();
   var seenMetals = new Array();
   var productVariants = product.variants;
   var productImages = product.images;
   var shapeFilter = jQuery("#setting_shape").val(); 
   var metalFilter = jQuery("#setting_metal").val();

   var metalOptionKey = 'option1';
   var shapeOptionKey = 'option2';
   if(product.options && product.options.length > 0){
     $(product.options).each(function(idx, optName){
       var name = (typeof optName === 'object' && optName.name) ? optName.name : optName;
       if(typeof name === 'string'){
         if(name.toLowerCase() === 'metal'){ metalOptionKey = 'option' + (idx + 1); }
         if(name.toLowerCase() === 'shape'){ shapeOptionKey = 'option' + (idx + 1); }
       }
     });
   }

  if(productVariants != ''){
     $(productVariants).each(function(index, option){
         var variantShape = option[shapeOptionKey];
         var variantMetal = option[metalOptionKey];

         // Skip variants that don't carry a metal value at all (bad/incomplete data)
         // instead of throwing when .match/.toLowerCase is called on null/undefined.
         if(variantMetal == null || variantMetal == ''){ return; }

         // Skip all 18K variants from the swatch display
         if(variantMetal.match(/^18K\s/i)){ return; }

         var metalClass = variantMetal.toLowerCase();
         metalClass = metalClass.replace(/\s+/g,"-");

         if(seenMetals.indexOf(variantMetal) !== -1){ return; }

         if(shapeFilter != '' && variantShape == shapeFilter){
             var active = '';
             if(metalFilter == variantMetal){
               var active = 'active'; 
             }
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;
             var rawImage = option.featured_image ? getImageByID(productImages,option.featured_image.id) : null;
             var rawSecondImage = option.featured_image ? getSecondImageByID(productImages,option.featured_image.id) : null;
             var imageResult = getSafeImageUrl(rawImage);
             var secondImageResult = getSafeImageUrl(rawSecondImage || imageResult.url);

             seenMetals.push(variantMetal);
             swatchesData.push({
                id: option.id,
                sku: option.sku,
                metal: variantMetal,
                shape: variantShape,
                class: metalClass,
                url: productUrl,
                active: active,
                image: imageResult.url,
                isPlaceholder: imageResult.isPlaceholder,
                price: option.price,
                comparePrice: option.compare_at_price,
                secondImage: secondImageResult.url,
             });
         }else if(shapeFilter == ''){
             var active = '';
             if(metalFilter == variantMetal){
               var active = 'active'; 
             }
           
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;             
             var rawImage = option.featured_image ? getImageByID(productImages,option.featured_image.id) : null;
             var rawSecondImage = option.featured_image ? getSecondImageByID(productImages,option.featured_image.id) : null;
             var imageResult = getSafeImageUrl(rawImage);
             var secondImageResult = getSafeImageUrl(rawSecondImage || imageResult.url);
           
             // Cap at 4: now safely shows 14K Rose, 14K White, 14K Yellow, Platinum
             if(swatchesData.length < 4){
               seenMetals.push(variantMetal);
               swatchesData.push({
                  id: option.id,
                  sku: option.sku,
                  metal: variantMetal,
                  shape: variantShape,
                  class: metalClass,
                  url: productUrl,
                  active: active,
                  image: imageResult.url,
                  isPlaceholder: imageResult.isPlaceholder,
                  price: option.price,
                  comparePrice: option.compare_at_price,
                  secondImage: secondImageResult.url,
               });
             }
         }
           
     });
   }
   return swatchesData;
}
/*** Get Product Swatches Data End ***/

/*** Get Image URL By Its ID Start ***/
function getImageByID(productImages,imageId) {
  var imageUrlArray = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });

  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/

/*** Get Second Image URL By Its ID Start ***/
function getSecondImageByID(productImages,imageId) {
  var imageUrlArray = new Array();
  var imageIndex = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){      
      var image_index = index+1;
      imageIndex.push(image_index);
    }

    if(imageIndex[0] == index){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });

  return imageUrlArray[0];
}
/*** Get Second Image URL By Its ID End ***/

/*** Safe Image Resolver Start ***/
// Central place that decides what image to show when a variant/product is
// missing a real photo. Never returns null/undefined/empty so callers can
// safely call string methods (.includes, .replace, etc.) on the result.
function getPlaceholderImageUrl(){
  if(typeof placeholderImageUrl !== 'undefined' && placeholderImageUrl && placeholderImageUrl.ring_placeholder){
    return placeholderImageUrl.ring_placeholder;
  }
  // Last-resort inline fallback if the theme forgot to define placeholderImageUrl at all,
  // so we still never hand back an empty/undefined src.
  return 'https://cdn.shopify.com/s/files/1/no-image-available.png';
}

function getSafeImageUrl(candidateUrl){
  if(candidateUrl && candidateUrl !== 'undefined' && candidateUrl !== 'null'){
    return { url: candidateUrl, isPlaceholder: false };
  }
  return { url: getPlaceholderImageUrl(), isPlaceholder: true };
}
/*** Safe Image Resolver End ***/
  
/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if (xhr && xhr.readyState != 4) {
    xhr.abort();
  }
}
/*** End ***/ 

/*** Onclick Product Store Product ID & Page No in Session Start ***/
jQuery(document).on("click", ".tps-productlist-result-grid-view-item", function(e) {
  var data_page_no = $(this).attr("data-page");
  var data_product_id = $(this).attr("data-id");
  
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', data_page_no);
  updateSessionFilters(session_variable+'-other-data','Product-Id', data_product_id);
});
/*** Onclick Product Store Product ID & Page No in Session End ***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyProductResultDiv(){   
  jQuery('.tps-productlist-result-grid-view-items-list').removeClass('tps-no-product-found');
  jQuery('.tps-productlist-result-grid-view-items-list').html('');
  /* Filters changed → reset to page 1 and clear URL param */
  jQuery('#page_no').val(1);
  if (getPaginationMode() === 'pagination') {
    setPageInUrl(1);
  }
  var resetFlag = checkResetFlag();
  if(resetFlag != 'true'){
    ajaxDataCall();
  } 
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(){
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#setting_shape').val('');

    $('.tps-filter-metal-li').removeClass('selected');
    $(".tps-filter-metal-checkbox").prop('checked', false);
    $('#setting_metal').val('');

    $('.tps-filter-style-li').removeClass('selected');
    $(".tps-filter-style-checkbox").prop('checked', false);
    $('#setting_style').val('');

    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     

    $('.tps-sort-option').removeClass('active');
    $('.tps-sort-price-ascending').addClass('active');
    // jQuery('.tps-sort-by-value').html('<span id="drp_icon">></span>');
    jQuery('.tps-sort-by-value').html('<span>'+translations.titlePriceSortLowToHigh+'</span>');
    
    jQuery('#sort_by').val('price-ascending');     

    updateSessionFilters(session_variable+'-other-data','Sort-By', 'price-ascending');
    updateSessionFilters(session_variable+'-other-data','Sort-Title', translations.titlePriceSortLowToHigh);
    
    jQuery('#page_no').val(1);
    if (getPaginationMode() === 'pagination') {
      setPageInUrl(1);
    }
    ajaxDataCall();

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Reset Filter Popup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-tab2");
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    jQuery(".tps-reset-filter-confirm-popup-div").hide();
  }
});
/*** Reset Filter Popup Close Outer Click End ***/

/* Try on the ring code */
function drawTryOnButton(container){
    const widgetId = 'ring-try-on-' + Math.random().toString(36).substr(2, 9);

    const btn = document.createElement('button');
    btn.id = widgetId;
    btn.innerHTML = '';
    
    btn.onmouseover = () => btn.innerText = 'Try On Rings';
    btn.onmouseout = () => btn.innerText = '';

    if (container) {
        container.appendChild(btn);
    } else {
        document.body.appendChild(btn);
    }

    let imageUrlWhite = container?.dataset.imageUrlWhite || (window.ringTryOnConfig && window.ringTryOnConfig.imageUrlWhite) || '';
    let imageUrlYellow = container?.dataset.imageUrlYellow || (window.ringTryOnConfig && window.ringTryOnConfig.imageUrlYellow) || '';
    let imageUrlRose = container?.dataset.imageUrlRose || (window.ringTryOnConfig && window.ringTryOnConfig.imageUrlRose) || '';
    let productId = container?.dataset.productId || (window.ringTryOnConfig && window.ringTryOnConfig.productId) || '';

    const params = new URLSearchParams({
        imageUrlWhite: encodeURIComponent(imageUrlWhite),
        imageUrlYellow: encodeURIComponent(imageUrlYellow),
        imageUrlRose: encodeURIComponent(imageUrlRose),
        productId: encodeURIComponent(productId)
    }).toString();

    const popup = document.createElement('div');
    popup.id = widgetId + '-popup';
    popup.style.cssText = 'display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 10000;';

    const popupContent = document.createElement('div');
    popupContent.className = 'tps-try-popup-wrapper';

    const closeBtn = document.createElement('button');
    closeBtn.innerText = '×';
    closeBtn.className = 'tps-try-on-close';

    let iframe = null;

    popupContent.appendChild(closeBtn);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);

    let isOpen = false;
    btn.onclick = function() {
        if (!isOpen) {
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.src = 'https://stuller.transpacific-software.com/tps-try-on-hand/ring-try-on-widget.html?' + params;
                iframe.style.cssText = 'width: 100%; height: 100%; border: none;';
                iframe.setAttribute('allow', 'camera; microphone');
                popupContent.appendChild(iframe);
            }
            popup.style.display = 'block';
            isOpen = true;
            document.body.style.overflow = 'hidden';
        }
    };

    closeBtn.onclick = function() {
        popup.style.display = 'none';
        isOpen = false;
        document.body.style.overflow = 'auto';
        if (iframe) {
            iframe.src = iframe.src;
        }
    };

    popup.onclick = function(e) {
        if (e.target === popup) {
            popup.style.display = 'none';
            isOpen = false;
            document.body.style.overflow = 'auto';
            if (iframe) {
                iframe.src = iframe.src;
            }
        }
    };

    btn.setAttribute('data-widget', 'protected');

    const protectStyles = () => {
        popup.style.cssText = 'display: ' + (isOpen ? 'block' : 'none') + '; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 10000;';
    };
    setInterval(protectStyles, 1000);

    const protect = () => {
        if (window.devtools && window.devtools.isOpen) {
            btn.style.display = 'none';
            setTimeout(() => btn.style.display = 'block', 1000);
        }
    };
    setInterval(protect, 1000);

    const updateIframeSize = () => {
        if (iframe) {
            iframe.style.width = '100%';
            iframe.style.height = '100%';
        }
    };

    const styleSheet = document.createElement('style');
    styleSheet.textContent = `
        @media (max-width: 768px) {
            #${widgetId}-popup > div {
                width: 95vw;
                height: 85vh;
                max-width: none;
                max-height: none;
            }
        }
        @media (max-width: 480px) {
            #${widgetId}-popup > div {
                width: 100vw;
                height: 100vh;
                border-radius: 0;
            }
        }
    `;
    document.head.appendChild(styleSheet);

    window.addEventListener('resize', updateIframeSize);
}
/* End */

/*** Product Quick View Popup Start ***/
window.tpsProductsCache = window.tpsProductsCache || {};

/* Inject modal markup + styles into <body> once, so no ancestor on desktop
   (overflow:hidden, transform, z-index stacking context) can clip or bury it. */
function ensureQuickViewMarkup(){
  if (document.getElementById('tps_quickview_overlay')) return;

  var overlay = document.createElement('div');
  overlay.className = 'tps-quickview-overlay';
  overlay.id = 'tps_quickview_overlay';
  overlay.innerHTML =
    '<div class="tps-quickview-modal" id="tps_quickview_modal">' +
      '<span type="button" class="tps-quickview-close" id="tps_quickview_close_btn">&times;</span>' +
      '<div id="tps_quickview_body"></div>' +
    '</div>';
  document.body.appendChild(overlay);

  // Close on backdrop click / close button / ESC
  overlay.addEventListener('click', function(e){
    if (e.target === overlay) closeProductQuickView();
  });
  document.getElementById('tps_quickview_close_btn').addEventListener('click', closeProductQuickView);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeProductQuickView();
  });
}

function cacheQuickViewProduct(product, productVariant, produtSwaches, images, isNew){
  window.tpsProductsCache[product.id] = {
    product: product,
    variant: productVariant,
    swatches: produtSwaches,
    images: images,
    isNew: isNew
  };
}

function openProductQuickView(productId){
  ensureQuickViewMarkup();
  var data = window.tpsProductsCache[productId];
  if(!data) return;
  renderQuickViewContent(data, data.variant[0]);
  var overlay = document.getElementById('tps_quickview_overlay');
  overlay.classList.add('tps-qv-active');
  document.body.classList.add('tps-quickview-open');
}

function closeProductQuickView(){
  var overlay = document.getElementById('tps_quickview_overlay');
  if(overlay) overlay.classList.remove('tps-qv-active');
  document.body.classList.remove('tps-quickview-open');
}

function renderQuickViewContent(data, activeVariant){
  var product = data.product;
  var produtSwaches = data.swatches;

  var productPrice = Shopify.formatMoney(activeVariant.price * 100, theme.moneyFormat);
  productPrice = productPrice.substr(0, productPrice.indexOf('.'));
  var productComparePrice = Shopify.formatMoney(activeVariant.comparePrice * 100, theme.moneyFormat);
  productComparePrice = productComparePrice.substr(0, productComparePrice.indexOf('.'));
  var totPrice = Number(activeVariant.comparePrice - activeVariant.price);
  totPrice = Shopify.formatMoney(totPrice * 100, theme.moneyFormat);
  totPrice = totPrice.substr(0, totPrice.indexOf('.'));

  var qvImageResult = getSafeImageUrl(activeVariant.image);
  var qvImageClass = qvImageResult.isPlaceholder ? 'tps-no-image' : '';
  var qvImageAlt = qvImageResult.isPlaceholder ? (product.title+' - image coming soon') : product.title;

  var html = '';
  if(data.isNew){
    html += '<div class="tps-quickview-badge">New In</div>';
  }
  html += '<div class="tps-quickview-image-wrap">';
  html += '<img class="'+qvImageClass+'" data-is-placeholder="'+qvImageResult.isPlaceholder+'" src="'+qvImageResult.url+'" alt="'+qvImageAlt+'">';
  html += '<div class="tps-quickview-wishlist xb-wishlist__btn-custom">';
  html += '  <div class="xb-wishlist__add" xb-product-id="'+product.id+'" xb-product-title="'+product.title.replace(/"/g,'&quot;')+'" xb-product-variant="'+activeVariant.id+'" xb-is-in-stock="true" xb-product-handle="'+product.handle+'">';
  html += '    <button aria-label="Add to Wishlist"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF4A71" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg></button>';
  html += '  </div>';
  html += '</div>';
  html += '</div>';
  //console.log('activeVariant',activeVariant);
  html += '<div class="tps-quickview-product-info-wrap">';
    html += '<div class="tps-quickview-title">'+product.title+'</div>';
    if(produtSwaches && produtSwaches.length){
      html += '<div class="tps-quickview-swatches-section">';
        html += '<span class="tps-quickview-color-label">Color</span>';
        html += '<div class="tps-quickview-swatches">';
        $.each(produtSwaches, function(i, swatch){
          var active = (swatch.id == activeVariant.id) ? 'active' : '';
          html += '<div class="tps-productlist-item-swatch '+active+'" title="'+swatch.metal+'" data-qv-swatch data-product-id="'+product.id+'" data-variant-id="'+swatch.id+'" onclick="changeProductData(`'+product.title+'`,`'+product.id+'`,`'+product.body_html+'`,`'+product.handle+'`,`'+swatch.id+'`,`'+swatch.metal+'`,`'+swatch.price+'`,`'+activeVariant.sku+'`,`'+activeVariant.shape+'`,`'+swatch.comparePrice+'`,`'+swatch.image+'`,`'+swatch.url+'`,`'+activeVariant.url+'`)">';
          html += '<span class="tps-productlist-item-metal-icon metal-'+swatch.class+'">'+swatch.metal+'</span>';
          html += '</div>';
        });
        html += '</div>';
      html += '</div>';
    }

    html += '<div class="tps-quickview-price-row">';
    html += '<span class="price-current">'+productPrice+'</span>';
    if(productComparePrice && productComparePrice != '$0'){
      html += '<span class="price-compare">'+productComparePrice+'</span>';
      html += '<span class="price-save">Save '+totPrice+'</span>';
    }
    html += '</div>';

    html += '<div class="tps-quickview-buttons">';
    html += '<a class="tps-qv-more-info" href="'+activeVariant.url+'">More Info</a>';
    html += '<button type="button" class="tps-qv-choose" data-qv-choose data-product-id="'+product.id+'">Choose Setting</button>';
    html += '</div>';

    html += '<div class="tps-quickview-shoppay">';
    html += '<div class="tps-shoppay-slot" data-product-id="'+product.id+'" data-variant-id="'+activeVariant.id+'"></div>';
    html += '</div>';
  html += '</div>';

  jQuery('#tps_quickview_body').html(html);
  initShopPayTermsBanners(jQuery('#tps_quickview_modal'));
}

function choose_this_listing_setting_from_quickview(productId){
  var btn = jQuery('.product-grid-item-'+productId+' #tps_choose_this_listing_setting')[0];
  if(btn){
    choose_this_listing_setting(btn);
    closeProductQuickView();
  }
}

/* Event delegation — robust across desktop/mobile and any re-rendered markup */
jQuery(document).on('click', '.tps-quickview-trigger', function(e){
  if (jQuery(window).width() <= 767) {
    e.preventDefault();
    var productId = jQuery(this).data('id');
    openProductQuickView(productId);
  }
  // else: do nothing extra — let the <a href> navigate normally, desktop untouched
});
jQuery(document).on('click', '[data-qv-swatch]', function(){ 
  var productId = jQuery(this).data('product-id');
  var variantId = jQuery(this).data('variant-id');
   //console.log('productId',productId);
   //console.log('variantId',variantId);
  var data = window.tpsProductsCache[productId];
  if(!data) return;
  var match = data.swatches.filter(function(s){ return s.id == variantId; })[0];
  if(!match) return;
  var activeVariant = {
    id: match.id, sku: match.sku, url: match.url, image: match.image,
    price: match.price, comparePrice: match.comparePrice
  };
  renderQuickViewContent(data, activeVariant);
});

jQuery(document).on('click', '[data-qv-choose]', function(){
  var productId = jQuery(this).data('product-id');
  choose_this_listing_setting_from_quickview(productId);
});

jQuery(function(){ ensureQuickViewMarkup(); });
/*** Product Quick View Popup End ***/